import React, { forwardRef } from 'react';

import { TextField } from '@material-ui/core';

import ControllerInput from './ControllerInput';

const TextInputBase = forwardRef(({ variant = 'outlined', ...rest }, ref) => (
  <TextField margin="normal" {...rest} inputRef={ref} variant={variant} />
));

function TextInput({
  name,
  group = 'default',
  priority = 1,
  visible = true,
  deps = [],
  disabled = false,
  mask,
  ...props
}) {
  return (
    <ControllerInput
      name={name}
      group={group}
      priority={priority}
      deps={deps}
      disabled={disabled}
      visible={visible}
      mask={mask}
      render={({ field }) => <TextInputBase {...props} {...field} />}
    />
  );
}

export default TextInput;
